import React from 'react'
import { bool, func, number } from 'prop-types'
import { translate } from 'react-i18next'

export const InquiryDetailsProposalCount = translate()(({ t, onlyOne, count }) => {
  let extras = []
  if (!count) {
    return <p className='demandes__mainlabel'>{t('common:visits:received_none')}</p>
  }

  if (onlyOne) {
    extras = [
      (<br />),
      t('common:visits:can_one_gardener')
    ]
  }
  return (
    <h3 className='demandes__mainlabel'>
      { t('common:visits:received_proposal', { count: count }) }
      { extras }
    </h3>
  )
})

InquiryDetailsProposalCount.propTypes = {
  t: func,
  onlyOne: bool,
  count: number
}



// WEBPACK FOOTER //
// ./src/components/inquiries/InquiryDetailsProposalCount.js